import styled from "styled-components";

const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 2rem 1rem;
  min-height: 500px;
  position: relative;
`;

export default SectionContainer;
